import { useEffect, useState } from 'react';
import { SuggestedPromptsResponse } from '../../models/suggested-prompts/SuggestedQuestions';
import { getSuggestedQuestions } from '../../services/suggested-prompts/SuggestedPromptsService';

const useSuggestedQuestions = (projectId: number) => {
  const [suggestedPromptsResponse, setSuggestedPromptsResponse] =
    useState<SuggestedPromptsResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const getQuestions = async () => {
    setLoading(true);
    try {
      const data = await getSuggestedQuestions(projectId);
      setSuggestedPromptsResponse(data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getQuestions();
  }, []);

  return { suggestedPromptsResponse, loading, error };
};

export default useSuggestedQuestions;
